declare global {
  interface Window {
    Rollbar: any;
  }
}

enum LogLevel {
  error,
  warn,
  info,
}
type LogLevelString = keyof typeof LogLevel;

/** wrap a string in Error to generate a trace for logging. */
function maybeWrapAsError(arg: string | Error) {
  if (!(arg instanceof Error)) {
    return new Error(arg);
  } else {
    return arg;
  }
}

/**
 * Reports some kind of message to console and Rollbar (if defined).
 *
 * Raw strings will be wrapped in an Error to preserve
 * a stack trace.
 *
 * @param logLevel
 * @param {Error|string} error
 * @param {object|string} info extra parameters to log, or a nice message
 * @param {any[]} rest any additional params for rollbar
 */
function reportToRollbar(logLevel: LogLevelString, message: string | Error, info?: any, ...rest: any[]) {
  // eslint-disable-next-line no-console
  console[logLevel](message, info, ...rest);

  if (typeof window !== `undefined` && window.Rollbar) {
    // Rollbar doesn't care what order you submit arguments in.
    window.Rollbar[logLevel](maybeWrapAsError(message), info, ...rest);
  }
}

function createReporterFunc(logLevel) {
  return function(message: string | Error, info?: any, ...rest: any[]) {
    reportToRollbar(logLevel, message, info, ...rest);
  };
}

/**
 * @example
 * reporter.info(`some message to report`);
 * reporter.error(new Error(`everything is on fire`));
 */
export const reporter = {
  error: createReporterFunc(`error`),
  warn: createReporterFunc(`warn`),
  info: createReporterFunc(`info`),
};
